import { CnBox } from '@cainiaofe/cn-ui';
import GridListBase from './base';

const GridList = GridListBase({ CnBox, coefficient: 1, unit: 'px' });

export default GridList;
